import React from 'react';
import { useHistory } from 'react-router';

// Constants
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import BaseUserSuggestionItem from './BaseUserSuggestionItem';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const ProvideFeedbackSuggestion = ({ userSuggestion, className }: Props) => {
  const history = useHistory();

  const handleOnClick = () => {
    history.push({
      pathname: PageUrlsUtils.makeFeedbackRequestUrl(userSuggestion.oneOnOneWorkspaceSlug),
      search: `${QueryParamsConstants.HIDE_KUDOS_CARD}=true`,
      state: { userSuggestionId: userSuggestion.slug },
    });
  };

  return (
    <BaseUserSuggestionItem
      userSuggestion={userSuggestion}
      btnLabel="Give Feedback"
      onClick={handleOnClick}
      className={className}
    />
  );
};

export default ProvideFeedbackSuggestion;
